"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "card card-amount-qr-codes"
  }, [_c("header", {
    staticClass: "card-header"
  }, [_c("p", {
    staticClass: "card-header-title"
  }, [_vm._v("\n      " + _vm._s(_vm.$t("pages.identifiers.cards.amount.title")) + "\n    ")])]), _vm._v(" "), _c("div", {
    staticClass: "card-content"
  }, [_c("b-field", [_c("the-mask", {
    ref: "input",
    staticClass: "input",
    attrs: {
      autocomplete: false,
      placeholder: _vm.$t("pages.identifiers.cards.amount.placeholder"),
      mask: ["#", "##", "###", "####"]
    },
    on: {
      input: _vm.onInput
    },
    model: {
      value: _vm.computedValue,
      callback: function callback($$v) {
        _vm.computedValue = $$v;
      },
      expression: "computedValue"
    }
  })], 1), _vm._v(" "), _c("p", [_vm._v("\n      " + _vm._s(_vm.$t("pages.identifiers.cards.amount.description")) + "\n    ")]), _vm._v(" "), _c("div", {
    staticClass: "content-btn"
  }, [_c("b-button", {
    attrs: {
      disabled: !_vm.computedValue
    },
    on: {
      click: _vm.actionItem
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("pages.identifiers.cards.amount.btn_action")) + "\n      ")])], 1)], 1)]);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;